import { render, staticRenderFns } from "./password-form-new.vue?vue&type=template&id=0e5ccba2"
import script from "./password-form-new.vue?vue&type=script&lang=js"
export * from "./password-form-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports